import {
  SURVEY_GET_DETAILS,
  SURVEY_GET_DETAILS_SUCCESS,
  SURVEY_GET_DETAILS_ERROR,
  SURVEY_DELETE_QUESTION,
  SURVEY_DELETE_PAGE,
  SURVEY_SAVE,
  MOVE_QUES_UP,
  MOVE_QUES_DOWN,
  UPT_QUES_OBJ,
  ADD_QUES,
  UPT_QUES,
  UPT_FORM,
  UPT_LAUNCH,
  UPT_LAUNCH_SERVER,
  SET_BRANCHING,
  UPT_TO_SERVER,
  SET_ACTIVE,
  SET_FORCE,
  SURVEY_LIST_DEL,
  SURVEY_LIST_DEL_SUCCESS,
  SURVEY_LIST_DEL_ERROR,
  FETCH_USER,
  UPT_USER,
  SURVEY_UPTSTRUC,
  UPT_PWI,
  SET_LOAD,
  SET_ROUND
} from '../actions';

export const getSurveyDetail = (id) => ({
  type: SURVEY_GET_DETAILS,
  payload: id,
});

export const getSurveyDetailSuccess = (items) => ({
  type: SURVEY_GET_DETAILS_SUCCESS,
  payload: items,
});

export const getSurveyUpt = (items) => ({
  type: SURVEY_UPTSTRUC,
  payload: items,
});

export const setRound = (items) => ({
  type: SET_ROUND,
  payload: items,
});

export const getSurveyDetailError = (error) => ({
  type: SURVEY_GET_DETAILS_ERROR,
  payload: error,
});

export const deleteSurveyQuestion = (pageid, questionId, survey) => ({
  type: SURVEY_DELETE_QUESTION,
  payload: { pageid, questionId, survey },
});

export const saveSurvey = (survey) => ({
  type: SURVEY_SAVE,
  payload: survey,
});

export const deleteSurveyPage = (pageId, survey) => ({
  type: SURVEY_DELETE_PAGE,
  payload: { pageId, survey },
});

export const moveUpQuestion = (pageid, quesid, quesitem) => ({
  type: MOVE_QUES_UP,
  payload: { pageid, quesid, quesitem },
});

export const deleteSurvey = (items) => ({
  type: SURVEY_LIST_DEL,
  payload: items,
});

export const moveDownQuestion = (pageid, quesid, quesitem) => ({
  type: MOVE_QUES_DOWN,
  payload: { pageid, quesid, quesitem },
});

export const addQuestion = (formid, pageid, survey) => ({
  type: ADD_QUES,
  payload: { formid, pageid, survey },
});
export const uptQues = (action, param, formid, pageid, quesid) => ({
  type: UPT_QUES,
  payload: {
    action,
    param,
    formid,
    pageid,
    quesid,
  },
});

export const uptForm = (id, formobj) => ({
  type: UPT_FORM,
  payload: { id, formobj },
});

export const uptQuesObj = (formid, pageid, quesid, quesobj) => ({
  type: UPT_QUES_OBJ,
  payload: { formid, pageid, quesid, quesobj },
});

export const setBranching = (items) => ({
  type: SET_BRANCHING,
  payload: items,
});

export const Sync = (id, sur) => ({
  type: UPT_TO_SERVER,
  payload: {id, sur},
});

export const setActiveSurvey = (id, param, sur) => ({
  type: SET_ACTIVE,
  payload: {id, param, sur},
});

export const setForceSurvey = (id, param, sur) => ({
  type: SET_FORCE,
  payload: {id, param, sur},
});

export const deleteSurveyItemSuccess = (items) => ({
  type: SURVEY_LIST_DEL_SUCCESS,
  payload: items,
});

export const deleteSurveyItemError = (error) => ({
  type: SURVEY_LIST_DEL_ERROR,
  payload: error,
});

export const FetchUser = (items) => {
  return {
  type: FETCH_USER,
  payload: items
}};

export const UptUser = (items) => {
  return {
  type: UPT_USER,
  payload: items
}};

export const UptLaunch = (items) => {
  return {
  type: UPT_LAUNCH,
  payload: items
}};

export const UptLaunchServer = (id, oldsur, sur) => ({
  type: UPT_LAUNCH_SERVER,
  payload: {id, oldsur, sur},
});

export const UptPwi = (link) => {
  return {
  type: UPT_USER,
  payload: link
}};

export const UptLoad = (loadaction) => ({
  type: SET_LOAD,
  payload: loadaction,
});
